import { Icon, IconProps } from "@chakra-ui/react";

const BulbOutlined = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <path
        d="M8.16667 17.6667H11.5M6.5 11.8333H13.1667M4 6.83333C4 5.28624 4.61458 3.80251 5.70855 2.70854C6.80251 1.61458 8.28624 1 9.83334 1C11.3804 1 12.8642 1.61458 13.9581 2.70854C15.0521 3.80251 15.6667 5.28624 15.6667 6.83333C15.6674 7.77259 15.4403 8.698 15.0048 9.53023C14.5694 10.3625 13.9387 11.0767 13.1667 11.6117L12.715 13.75C12.6552 14.1441 12.4561 14.5038 12.1538 14.7637C11.8516 15.0236 11.4662 15.1666 11.0675 15.1667H8.59917C8.20052 15.1666 7.8151 15.0236 7.51283 14.7637C7.21056 14.5038 7.01147 14.1441 6.95167 13.75L6.5 11.6208C5.72774 11.084 5.09697 10.3681 4.66161 9.53434C4.22624 8.70062 3.99924 7.77388 4 6.83333Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default BulbOutlined;
